import { render } from "./Experience.vue?vue&type=template&id=470db460&scoped=true"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"

import "./Experience.vue?vue&type=style&index=0&id=470db460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470db460"]])

export default __exports__